import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SucursalService } from '../../../sucursal/services/sucursal.service';
import { EmpresaService } from '../../../empresa/services/empresa.service';
import { StatusService } from '../../../../services/status/status.service';
import { StorageService } from '@global-service/storage';
import { environment } from '@environment/environment';
import { EventosCompartidosService } from '@global-service/eventosCompartidos/eventosCompartidos.service';

@Component({ standalone: false, selector: 'app-dashboard-index',
  templateUrl: './index.component.html',
})
export class DashboardIndexPage implements OnInit {

  tamBar = "col-md-3 col-lg-2";
  tamDashboard = "col-md-9 col-lg-10";

  constructor(private readonly router: Router, private readonly empresaService: EmpresaService, private readonly sucursalService: SucursalService, private readonly statusService: StatusService, private readonly storageService: StorageService, private readonly eventosCompartidos: EventosCompartidosService) {
    this.eventosCompartidos.setEnPaginaClientesBackOffice(false);
   }

  ngOnInit() {
    if(!this.storageService.getIsAdmin() && environment.production) {
      window.console.log = () => {};
    }
  }
  dblClickNodeHandler(node) {
    this.statusService.cambiarEstadoTienda(node);    
  }

  onHidden(isHidden) {
    if (isHidden) {
      this.tamBar = "col-md-0-5";
      this.tamDashboard = "col-md-11-5";
    }
    else {
      this.tamBar = "col col-md-3 col-lg-2";
      this.tamDashboard = "col-md-9 col-lg-10";
    }
  }

}
